<script setup lang="ts">
const props = defineProps<{
  id: string;
  label?: string;
}>();

const defaultLabel = 'Would you like the transfer fee to be covered?';
</script>
<template>
  <BxField v-slot="{ field }" name="transferFeeCovered">
    <BxRadio
      v-bind="field"
      :id="id + '-transfer-fee-covered'"
      :data-test-id="`${id}-transfer-fee-covered`"
      :label="props.label ?? defaultLabel"
      label-type="default"
      class="form-control incoming-margin-top"
      boolean
    />
  </BxField>
</template>
